import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/**
* hidden: true                   如果“hidden:true”不会显示在侧边栏中(默认为false)
* alwaysShow: true               true：始终显示根菜单，如果没有children字段将不会显示（空数组也会显示），需要设置meta.title才会有根菜单标题
*                                false：多个子路由会显示根菜单，一个子路由不会显示根菜单
* defaultOpends: false           默认展开menu
* redirect: noredirect           如果'redirect:noredirect '将不会在面包屑重定向 ？
* name:'router-name'             名称由<keep-alive>使用(必须设置!!!)
* meta : {
    roles: ['admin','editor']    将控制页面角色(您可以设置多个角色)
    title: 'title'               子菜单和面包屑中显示的名称(推荐设置)
    icon: 'svg-name'             侧边栏item左侧图标，svg的名称
    noCache: true                如果为true，页面将不会被缓存(默认为false)，tags-view缓存
    showBreadcrumb: true         如果为true, 页面将不显示面包屑
    groupTitle: '',              只支持一级菜单，连续设置一致的名称将会被无视
    vipExclude: [],             cms版本黑名单，某些版本不允许访问的页面
    vipInclude: [],             cms版本白名单，某些版本允许访问的页面
  }
**/

import Layout from './modules/layout'
import devLogin from './devLogin'
import devComponents from './devComponents'
import cmsWebSite from './modules/cmsWebSite'
import pidManage from './modules/pidManage'
import userManage from './modules/userManage'
import distributionManage from './modules/distributionManage'
import pkEdit from './modules/pkEdit'
import fangdanAudit from './modules/fangdanAudit'
import noticeManage from './modules/noticeManage'
import dataStatistics from './modules/dataStatistics'
import kzManage from './modules/kzManage'
import appAdminManage from './modules/appManage'
import helpManage from './modules/helpManage'
import miniProgram from './modules/miniProgram'
import sensitive from './modules/sensitive'

// 登录页或不需要权限的路由
export const constantRouterMap = [
  {
    path: '/404',
    name: 'ErrorPage404',
    component: () => import(/* webpackChunkName: "404" */ '@v/errorPage/404'),
    meta: { title: '404' },
    hidden: true,
  },

  // 开发环境登录
  ...devLogin,
]

// 放单中心&要权限的路由
export const asyncRouterMap = [

  {
    path: '/external-link',
    component: Layout,
    meta: { roles: ['taoke'] },
    children: [
      {
        path: 'https://admin.zhutui.cn/fangdan',
        meta: { title: '进入放单中心', icon: 'exchange' },
      },
    ],
  },

  // 淘客首页
  {
    path: '',
    component: Layout,
    redirect: 'index',
    name: 'baseIndex',
    meta: { roles: ['taoke'] },
    children: [
      {
        path: 'index',
        name: 'Index',
        component: () => import(/* webpackChunkName: "Home" */ '@v/index/v2'),
        meta: { title: '首页', icon: 'main' },
      },

      // {
      //   path: 'index',
      //   name: 'Index',
      //   component: () => import(/* webpackChunkName: "Home" */ '@v/index'),
      //   meta: { title: '首页', icon: 'main' }
      // },
      // {
      //   path: 'v2index',
      //   name: 'v2Index',
      //   component: () => import(/* webpackChunkName: "Home" */ '@v/index/v2'),
      //   meta: { title: 'v2首页', icon: 'main' },
      //   hidden: true,
      // },
    ],
  },

  // 管理员首页
  {
    path: '',
    component: Layout,
    redirect: 'index',
    name: 'adminIndex',
    meta: { roles: ['admin'] },
    children: [
      {
        path: 'index',
        name: 'Index',
        component: () => import(/* webpackChunkName: "adminHome" */ '@v/adminIndex'),
        meta: { title: '首页', icon: 'main_admin' },
      },
    ],
  },


  // vip充值
  {
    path: '/cms-website/upgrade',
    component: Layout,
    meta: { roles: ['taoke'] },
    children: [
      {
        path: '',
        name: 'CMSWebSiteUpgrade',
        component: () => import(/* webpackChunkName: "upgrade" */ '@v/cmsWebSite/upgrade'),
        meta: { title: '版本管理', icon: 'ic_version' },
      },
    ],
  },


  // // 修复cmsWebSite在侧边栏收起的情况下不会显示子路由
  // // 具体原因未知
  // {
  //   path: '/cms-website2',
  //   component: Layout,
  //   meta: { title: 'CMS网站', icon: 'cms', groupTitle: '推广渠道', roles: ['taoke'] },
  //   name: 'CMSWebSite2',
  //   redirect: 'overview',
  // },


  // 修复cmsWebSite在侧边栏收起的情况下不会显示子路由
  // 具体原因未知
  {
    path: '/cms-website2',
    component: Layout,
    meta: { title: 'CMS网站', icon: 'cms', groupTitle: '推广渠道', roles: ['taoke'] },
    name: 'CMSWebSite2',
    redirect: 'overview',
  },

  // CMS网站
  cmsWebSite,

  // 导购app（快捷入口）
  {
    path: '/shortcut_entry/appManage',
    component: Layout,
    meta: { groupTitle: '推广渠道', roles: ['taoke'] },
    children: [
      {
        path: 'appManage',
        redirect: '/extension/appManage',
        meta: { title: '导购APP', icon: 'app'},
      },
    ],
  },

  // 淘客小程序（快捷入口）
  {
    path: '/shortcut_entry/wxMiniProgram',
    component: Layout,
    meta: { groupTitle: '推广渠道', roles: ['taoke'] },
    children: [
      {
        path: 'wxMiniProgram',
        redirect: '/extension/wxMiniProgram',
        meta: { title: '淘客小程序', icon: 'el_icon_littleprogram'},
      },
    ],
  },


  // 导购APP
  // {
  //   path: '/guide-app',
  //   component: Layout,
  //   meta: { groupTitle: '推广渠道', roles: ['taoke'] },
  //   children: [
  //     {
  //       path: '',
  //       name: 'GuideApp',
  //       component: () => import(/* webpackChunkName: "guideApp" */ '@v/guideApp'),
  //       meta: { title: '导购APP', icon: 'app' }
  //     }
  //   ]
  // },

  // 淘客工具
  // {
  //   path: '/tools',
  //   component: Layout,
  //   meta: { groupTitle: '推广渠道', roles: ['taoke'] },
  //   children: [
  //     {
  //       path: '',
  //       name: 'Tools',
  //       component: () => import(/* webpackChunkName: "tools" */ '@v/tools'),
  //       meta: { title: '淘客工具', icon: 'tool' }
  //     }
  //   ]
  // },

  // 扩展功能
  {
    path: '/extension',
    component: Layout,
    meta: { groupTitle: '推广渠道', roles: ['taoke'] },
    name: 'Extensions',
    children: [
      {
        path: '',
        name: 'Extension',
        component: () => import(/* webpackChunkName: "extension" */ '@v/extension'),
        meta: { title: '扩展功能', icon: 'expand' },
      },
      {
        path: 'sms',
        name: 'ExtensionSMS',
        hidden: true,
        component: () => import(/* webpackChunkName: "extension" */ '@v/extension/sms'),
        meta: { title: '短信发送' },
      },
      {
        path: 'checkin',
        name: 'ExtensionCheckin',
        hidden: true,
        component: () => import(/* webpackChunkName: "extension" */ '@v/extension/checkin'),
        meta: { title: '签到功能' },
      },
      {
        path: 'search',
        name: 'ExtensionSearch',
        hidden: true,
        component: () => import(/* webpackChunkName: "extension" */ '@v/extension/search'),
        meta: { title: '搜索接口' },
      },
      // 废弃
      // {
      //   path: 'domain',
      //   name: 'ExtensionDomain',
      //   hidden: true,
      //   component: () => import(/* webpackChunkName: "extension" */ '@v/extension/domain'),
      //   meta: { title: '域名服务' }
      // },
      {
        path: 'tgstore',
        name: 'ExtensionTgstore',
        hidden: true,
        component: () => import(/* webpackChunkName: "extension" */ '@v/extension/tgstore'),
        meta: { title: '推广小店' },
      },
      {
        path: 'gfredpack',
        name: 'ExtensionGFredpack',
        hidden: true,
        component: () => import(/* webpackChunkName: "extension" */ '@v/extension/gfredpack'),
        meta: { title: '官方红包' },
      },
      {
        path: 'txhb',
        name: 'ExtensionTXHB',
        hidden: true,
        component: () => import(/* webpackChunkName: "extension" */ '@v/extension/txhb'),
        meta: { title: '提现红包' },
      },
      {
        path: 'wechatlogin',
        name: 'ExtensionWechatlogin',
        hidden: true,
        component: () => import(/* webpackChunkName: "extension" */ '@v/extension/wechatlogin'),
        meta: { title: '一键登录' },
      },
      {
        path: 'lyg',
        name: 'ExtensionLyg',
        hidden: true,
        component: () => import(/* webpackChunkName: "extension" */ '@v/extension/lyg'),
        meta: { title: '首单0元购' },
      },
      {
        path: 'xsms',
        name: 'ExtensionXsms',
        hidden: true,
        component: () => import(/* webpackChunkName: "extension" */ '@v/extension/xsms'),
        meta: { title: '超级秒杀' },
      },
      {
        path: 'xsms_add',
        name: 'ExtensionXsmsAdd',
        hidden: true,
        component: () => import(/* webpackChunkName: "extension" */ '@v/extension/xsms/add'),
        meta: { title: '添加商品' },
      },
      {
        path: 'xsms_edit_:id',
        name: 'ExtensionXsmsEdit',
        hidden: true,
        component: () => import(/* webpackChunkName: "extension" */ '@v/extension/xsms/edit'),
        meta: { title: '编辑商品' },
      },
      {
        path: 'flashsale',
        name: 'ExtensionFlashsale',
        hidden: true,
        component: () => import(/* webpackChunkName: "extension" */ '@v/extension/flashsale'),
        meta: { title: '限时抢购' },
      },
      {
        path: 'fljqr',
        name: 'Extensionfljqr',
        hidden: true,
        component: () => import(/* webpackChunkName: "extension" */ '@v/extension/fljqr/fljqr'),
        meta: { title: '返利机器人' },
      },
      {
        path: 'wxloginTmpmsg',
        name: 'ExtensionwxloginTempmsg',
        hidden: true,
        component: () => import(/* webpackChunkName: "extension" */ '@v/extension/wxloginTmpmsg'),
        meta: { title: '服务号消息' },
      },
      {
        path: 'boutique',
        name: 'Extensionboutique',
        hidden: true,
        component: () => import(/* webpackChunkName: "extension" */ '@v/extension/boutique'),
        meta: { title: '精品单页' },
      },
      {
        path: 'wxautoreply',
        name: 'Extensionwxautoreply',
        hidden: true,
        component: () => import(/* webpackChunkName: "extension" */ '@v/extension/wxautoreply/index'),
        meta: { title: '公众号关键词找券' },
      },
      {
        path: 'appManage',
        name: 'ExtensionappManage',
        hidden: true,
        component: () => import(/* webpackChunkName: "extension" */ '@v/extension/appManage/index'),
        meta: { title: '导购APP' },
      },
      {
        path: 'wxMiniProgram',
        name: 'ExtensionWxMiniProgram',
        hidden: true,
        component: () => import(/* webpackChunkName: "extension" */ '@v/extension/wxMiniProgram/index'),
        meta: { title: '微信小程序' },
      },
      {
        path: 'food',
        name: 'ExtensionFood',
        hidden: true,
        component: () => import(/* webpackChunkName: "extension.food" */ '@/views/extension/food/index'),
        meta: { title: '外卖优惠' },
      },
      {
        path: 'activate',
        name: 'ExtensionActivate',
        hidden: true,
        component: () => import(/* webpackChunkName: "extension.activate" */ '@/views/extension/activate/index'),
        meta: { title: '用户激活' },
      },
      {
        path: 'taxi',
        name: 'ExtensionTaxi',
        hidden: true,
        component: () => import(/* webpackChunkName: "extension.taxi" */ '@/views/extension/taxi/index'),
        meta: { title: '打车优惠' },
      },
    ],
  },

  // pid管理
  ...pidManage,

  // 分销管理
  ...distributionManage,

  // 用户管理
  userManage,

  // 财务中心
  {
    path: '/finance',
    component: Layout,
    badge: 'applyCashMsg',
    meta: { groupTitle: '通用', roles: ['taoke'], title: '财务中心', icon: 'finance' },
    children: [
      // {
      //   path: '',
      //   name: 'Finance',
      //   component: () => import(/* webpackChunkName: "finance" */ '@v/finance'),
      //   meta: { title: '订单和提现' }
      // },
      {
        path: '',
        name: 'Order',
        component: () => import(/* webpackChunkName: "finance" */ '@v/finance/order'),
        meta: { title: '订单管理' },
      },
      {
        path: 'withdraw',
        name: 'Withdraw',
        badge: 'applyCashMsg',
        component: () => import(/* webpackChunkName: "finance" */ '@v/finance/withdraw/withdraw'),
        meta: { title: '提现管理' },
      },
      {
        path: 'results',
        name: 'Results',
        component: () => import(/* webpackChunkName: "finance" */ '@v/finance/results/results'),
        hidden: true,
        meta: { title: '支付宝发放结果' },
      },
      {
        path: 'cms-balance',
        name: 'cmsBalance',
        component: () => import(/* webpackChunkName: "finance" */ '@v/finance/cmsBalance'),
        meta: { title: '余额增减' },
      },
    ],
  },

  // 个人中心
  {
    path: '/my-center',
    component: Layout,
    meta: { groupTitle: '通用', roles: ['taoke'] },
    children: [
      {
        path: '',
        name: 'MyCenter',
        component: () => import(/* webpackChunkName: "myCenter" */ '@v/myCenter'),
        meta: { title: '个人中心', icon: 'mine' },
      },
      {
        path: 'tui-coin',
        name: 'MyCenterMoneyCenter',
        hidden: true,
        component: () => import(/* webpackChunkName: "tuiCoin" */ '@v/myCenter/tuiCoin'),
        meta: {
          title: '推币中心',
          icon: 'main',
        },
      },
      {
        path: 'rechange',
        name: 'MyCenterRechange',
        hidden: true,
        component: () => import(/* webpackChunkName: "myCenterRechange"*/ '@v/myCenter/rechange'),
        meta: { title: '充值推币' },
      },
    ],
  },


  // 邀请赚钱
  {
    path: '/invitation',
    component: Layout,
    meta: { groupTitle: '通用', roles: ['taoke'] },
    children: [
      {
        path: '',
        name: 'Invitaion',
        meta: { title: '邀请赚钱', icon: 'money' },
        component: () => import(/* webpackChunkName: "invitation" */ '@v/invitation'),
      },
    ],
  },


  // 自定义文案
  {
    path: '/custom-text',
    component: Layout,
    meta: { groupTitle: '通用', roles: ['taoke'] },
    children: [
      {
        path: '',
        name: 'CustomText',
        meta: { title: '自定义文案', icon: 'ic_customtext' },
        component: () => import(/* webpackChunkName: "CustomText"*/ '@v/customText'),
      },
    ],
  },

  //自定义主题色
  // {
  //   path: '/theme',
  //   component: Layout,
  //   meta: { groupTitle: '通用', roles: ['taoke'] },
  //   children: [
  //     {
  //       path: '',
  //       name: 'Theme',
  //       meta: { title: '主题设置', icon: 'mine' },
  //       component: () => import(/* webpackChunkName: "Theme"*/ '@v/theme')
  //     }
  //   ]
  // },

  // 品库编辑
  ...pkEdit,


  // 关注列表
  // {
  //   path: '/follow',
  //   component: Layout,
  //   meta: { groupTitle: '品库后台', roles: ['taoke'] },
  //   children: [
  //     {
  //       path: '',
  //       name: 'Follow',
  //       component: () => import(/* webpackChunkName: "follow" */ '@v/follow'),
  //       meta: { title: '关注列表', icon: 'follow' }
  //     }
  //   ]
  // },

  {
    path: '/message',
    component: Layout,
    meta: { roles: ['taoke'] },
    hidden: true,
    children: [
      {
        path: '',
        name: 'Message',
        component: () => import(/* webpackChunkName: "Message"*/ '@v/message'),
        meta: { title: '消息中心', icon: 'message' },
      },
    ],
  },

  // 放单审核
  ...fangdanAudit,

  //公告管理
  ...noticeManage,

  //快站管理
  ...kzManage,

  //数据统计
  ...dataStatistics,

  //app管理
  ...appAdminManage,

  //帮助管理
  ...helpManage,

  // 敏感词管理
  ...sensitive,

  // app测试
  {
    path: '/adminAppTest',
    component: Layout,
    meta: { groupTitle: '品库后台', roles: ['admin'] },
    children: [
      {
        path: '',
        name: 'adminAppTest',
        component: () => import(/* webpackChunkName: "adminAppTest"*/ '@v/adminAppTest'),
        meta: { title: 'App测试', icon: 'admin_app_test' },
      },
    ],
  },

  // 小程序管理后台
  ...miniProgram,

  // 测试页面
  ...devComponents,



  // 刷新中间页
  {
    path: '/refresh',
    hidden: 'true',
    component: Layout,
    children: [
      {
        path: '',
        name: 'refresh',
        component: () => import(/* webpackChunkName: "Message"*/ '@v/refresh'),
        meta: {
          title: 'refresh',
          hideTagsView: true,
        },
      },
    ],
  },

  {
    path: '*',
    redirect: '/404',
    hidden: true,
  },
]


export default new Router({
  scrollBehavior: () => ({
    y: 0,
  }),
  routes: constantRouterMap,
})
